import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { ArticleDraftForm } from 'web_core/assets/draft/Article/Form'
import { usePopupMessage } from 'web_core/assets/messenger'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useRequireSignedIn } from 'web_core/firebase/hooks/useRequireSignedIn'
import { useArticleDraft } from 'web_core/hooks'
import { useQueryData } from 'web_core/hooks/useQueryData'
import { getDefaultStaticPaths } from 'web_core/utils/static_paths'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'

export const getStaticPaths = getDefaultStaticPaths

export const getStaticProps = makeLocaleStaticProps

export const Page: NextPage = () => {
  useRequireSignedIn()
  const router = useRouter()
  const id = useQueryData()
  const { articleDraft, notFound } = useArticleDraft(id)
  const { setPopupMessage } = usePopupMessage()

  useEffect(() => {
    if (notFound)
      void router
        .push('/article_drafts')
        .then(() =>
          setPopupMessage('存在しないかアクセス権限がありません。', 'danger')
        )
  }, [notFound])

  return (
    <DefaultLayout
      head={{
        title: '記事の編集',
        index: false,
      }}
      header={{ pc: { fixed: false }, sp: { show: false } }}
      overflow={{ pc: false, sp: true }}
      padding={{ pc: true, sp: false }}
    >
      {articleDraft ? (
        <ArticleDraftForm
          draft={articleDraft}
          className="h-100 position-relative"
        />
      ) : (
        <LoadingSpinner />
      )}
    </DefaultLayout>
  )
}

export default Page
